import { Clapperboard } from "lucide-react";

// Deterministic cinematic poster placeholder derived from the movie title.
const palettes = [
  ["#7f1d1d", "#0a0a0a"],
  ["#1e3a8a", "#0a0a0a"],
  ["#134e4a", "#0a0a0a"],
  ["#713f12", "#0a0a0a"],
  ["#581c87", "#0a0a0a"],
  ["#7c2d12", "#0a0a0a"],
  ["#0c4a6e", "#0a0a0a"],
  ["#4a044e", "#0a0a0a"],
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export const MoviePoster = ({ title, className = "" }) => {
  const h = hashString(title || "movie");
  const [c1, c2] = palettes[h % palettes.length];
  const angle = 120 + (h % 90);

  return (
    <div
      className={`relative overflow-hidden ${className}`}
      style={{ background: `linear-gradient(${angle}deg, ${c1}, ${c2})` }}
      data-testid="movie-poster"
    >
      {/* film perforations */}
      <div className="absolute left-0 inset-y-0 w-3 flex flex-col justify-around opacity-30">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="mx-auto w-1.5 h-1.5 rounded-[2px] bg-black" />
        ))}
      </div>
      <div className="absolute right-0 inset-y-0 w-3 flex flex-col justify-around opacity-30">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className="mx-auto w-1.5 h-1.5 rounded-[2px] bg-black" />
        ))}
      </div>

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/30" />

      <div className="relative h-full flex flex-col items-center justify-center px-4 py-6 text-center">
        <Clapperboard className="w-6 h-6 text-white/50 mb-3" />
        <span className="font-display font-black leading-tight text-white text-lg sm:text-xl line-clamp-4 drop-shadow">
          {title}
        </span>
      </div>
    </div>
  );
};
